import React from 'react';
import { Box, Button, Heading, Text } from '@wix/design-system';
import s from './ConfirmPlan.scss';
import { getTimeText, getFullDurationText } from '../utils';
export const ConfirmPlan = _ref => {
  let {
    data: {
      plan
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const isRecurring = plan.duration.isRecurring;
  const hasPerks = plan.perks.length > 0;
  const getPlanFrequency = () => {
    const count = plan.duration.cycleLength;
    const unit = plan.duration.timeUnit;
    return `Every ${getTimeText({
      unit,
      count
    })}`;
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, "Plan preview:"), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "204px",
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    className: hasPerks ? s.cardWithPerks : s.card,
    direction: "vertical",
    paddingTop: "SP4",
    paddingRight: "SP3",
    paddingBottom: "SP2",
    paddingLeft: "SP3",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(Box, {
    wordBreak: "break-word",
    align: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, plan.name)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, plan.price.currency), /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge"
  }, plan.price.value)), isRecurring && /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "tiny"
  }, getPlanFrequency()))), plan.description && /*#__PURE__*/React.createElement(Box, {
    wordBreak: "break-word",
    align: "center",
    paddingRight: "SP1",
    paddingLeft: "SP1",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, plan.description)), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "12px",
    direction: "vertical",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    light: true,
    secondary: true,
    size: "tiny"
  }, getFullDurationText(plan.duration)))), hasPerks && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP4",
    className: s.perksCard,
    gap: "6px"
  }, plan.perks.map(perk => /*#__PURE__*/React.createElement(Box, {
    align: "center",
    key: perk,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, perk))))), /*#__PURE__*/React.createElement(Box, {
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: () => {
      send('The plan looks great, lets create it!');
      onWidgetAction(PRICING_PLANS_CONFIRM_PLAN, {
        action: 'create plan',
        value: plan
      });
    },
    className: s.button
  }, "Create Plan")));
};
export const PRICING_PLANS_CONFIRM_PLAN = 'PRICING_PLANS_CONFIRM_PLAN';
//# sourceMappingURL=ConfirmPlan.js.map